import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { PAGE_SHORTCUTS, ShortcutTarget } from '../global/constants/page-shortcut';
import { ShortcutBinding } from '../../proxy/models/shortcut-binding';

@Injectable({
  providedIn: 'root',
})
export class ShortcutService {
  private router = inject(Router);
  private customShortcutSubject = new Subject<ShortcutBinding>();
  public customShortcut$: Observable<ShortcutBinding> = this.customShortcutSubject.asObservable();

  private shortcuts: ShortcutBinding[] = Object.values(PAGE_SHORTCUTS);
  public readonly chordActive = signal(false);
  public isNavigationOpen = signal(false);
  private chordTimeout: any;

  public handleKeydown(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    if (
      target &&
      (['INPUT', 'TEXTAREA', 'BUTTON'].includes(target.tagName) ||
        target.isContentEditable)
    ) {
      return;
    }

    const key = event.key.toLowerCase();
    const isMac = navigator.platform.toUpperCase().includes('MAC');
    const primaryModifier = isMac ? event.metaKey : event.ctrlKey;

    if (primaryModifier && key === 'k') {
      event.preventDefault();
      event.stopPropagation();

      this.chordActive.set(true);

      clearTimeout(this.chordTimeout);
      this.chordTimeout = setTimeout(() => this.chordActive.set(false), 500);
      return;
    }

    if (this.chordActive()) {
      for (const shortcut of this.shortcuts) {
        if (key === shortcut.key.toLowerCase()) {
          event.preventDefault();
          event.stopPropagation();

          this.chordActive.set(false);
          clearTimeout(this.chordTimeout);

          if (shortcut.target && shortcut.action === 'navigate') {
            if (shortcut.id === ShortcutTarget.SharedBoards || shortcut.id === ShortcutTarget.MyBoards) {
              this.router.navigateByUrl('/', {skipLocationChange: true}).then(async () => {
                await this.router.navigateByUrl(shortcut.target as unknown as string, { replaceUrl: true });
              });
            } else {
              this.router.navigateByUrl(shortcut.target);
            }
            break;
          } else if (shortcut.action === 'custom') {
            this.customShortcutSubject.next(shortcut);

            break;
          }
        }
      }
    }
  }
}
